export const buildUrl = (
  baseUrl: string,
  params: Record<string, string | undefined>,
): string => {
  const url = new URL(baseUrl);
  const urlParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      urlParams.append(key, value);
    }
  });

  url.search = urlParams.toString();

  return url.href;
};
